window.BAO.EVENTS = {
  CART_NOTE: {
    BEFORE_CHANGE: 'BEFORE_CHANGE',
    AFTER_CHANGE: 'AFTER_CHANGE',
  },
  PRODUCT: {
    OPTION_CHANGED: 'OPTION_CHANGED',
    OPTION_ENTERED: 'OPTION_ENTERED',
    OPTION_SELECTED: 'OPTION_SELECTED',
  },
  QUANTITY_ADJUSTER: {
    CHANGE: 'BAO::EVENTS::QUANTITY_ADJUSTER::CHANGE',
  },
  CART_VARIANT_UPDATER: {
    CHANGE: 'BAO::EVENTS::CART_VARIANT_UPDATER::CHANGE',
  },
  PUSH_CART: {
    BEFORE_ADD: 'BEFORE_ADD',
    AFTER_ADD: 'AFTER_ADD',
    BEFORE_ADD_FROM_FORM: 'BEFORE_ADD_FROM_FORM',
    AFTER_ADD_FROM_FORM: 'AFTER_ADD_FROM_FORM',
    BEFORE_MULTIPLE_ADD: 'BEFORE_MULTIPLE_ADD',
    AFTER_MULTIPLE_ADD: 'AFTER_MULTIPLE_ADD',
    BEFORE_UPDATE_REMOVE_ITEM: 'BEFORE_UPDATE_REMOVE_ITEM',
    AFTER_UPDATE_REMOVE_ITEM: 'AFTER_UPDATE_REMOVE_ITEM',
    BEFORE_UPDATE_ITEM_QUANTITY: 'BEFORE_UPDATE_ITEM_QUANTITY',
    AFTER_UPDATE_ITEM_QUANTITY: 'AFTER_UPDATE_ITEM_QUANTITY',
    BEFORE_UPDATE_CART_ATTRIBUTES: 'BEFORE_UPDATE_CART_ATTRIBUTES',
    AFTER_UPDATE_CART_ATTRIBUTES: 'AFTER_UPDATE_CART_ATTRIBUTES',
    CHANGED: 'CHANGED',
  },
}

window.BAO.eventBus = new window.BAO.EventBus()
window.BAO.dispatchEvent = window.BAO.eventBus.dispatchEvent.bind(
  window.BAO.eventBus,
)
